'use client'

import { useEffect, useRef } from 'react'
import { toast } from 'sonner'
import { useAppSession } from '@/state/session/context'
import { useOnlineStatus } from '@/lib/config/online-status'

export function OfflineSyncManager() {
  const { session } = useAppSession()
  const { isOnline } = useOnlineStatus()
  const lastOnlineRef = useRef<boolean>(isOnline)

  useEffect(() => {
    const wasOnline = lastOnlineRef.current
    lastOnlineRef.current = isOnline

    if (!isOnline) return
    if (wasOnline) return
    if (session.offlineQueue.items.length === 0) return
    if (session.offlineQueue.syncing) return

    toast.message('Modo offline legado desativado. Recarregando dados no servidor.')

    if (typeof window !== 'undefined') {
      window.dispatchEvent(new Event('habitpack:habits-updated'))
      window.dispatchEvent(new Event('habitpack:gestao-updated'))
      window.dispatchEvent(new Event('habitpack:profile-updated'))
    }
  }, [isOnline, session.offlineQueue.items.length, session.offlineQueue.syncing])

  return null
}

